export const handleLockScroll = (isLocked: boolean): void => {
    document.body.style.overflow = isLocked ? 'hidden' : 'unset';
};
